import { Component, inject } from '@angular/core';
import { NgbPopover, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { IccImportHistoryComponent } from '../icc-import-history/icc-import-history.component';
import { IccOrphanExemptionDrugImportsService } from '../../../core/services/icc/icc-orphan-exemption-drug-imports.service';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ClientSelectComponent } from '../../../shared/components/client-select/client-select.component';

@Component({
  selector: 'app-icc-import-orphan-exemption-drugs-history',
  templateUrl: '../icc-import-history/icc-import-history.component.html',
  imports: [ImportNavComponent,
    FormsModule,
    PaginationHeaderComponent,
    ClientSelectComponent,
    FaIconComponent,
    NgbPopover,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    PaginationComponent,
    MatProgressSpinner,
    DecimalPipe,
    TitleCasePipe,
    DatePipe]
})
export class IccImportOrphanExemptionDrugsHistoryComponent extends IccImportHistoryComponent {
  private orphanExemptionDrugImportsService = inject(IccOrphanExemptionDrugImportsService);

  pageTitle = 'Orphan Exemption Import History';

  getImports(paging, filters) {
    return this.orphanExemptionDrugImportsService.getList(paging, filters);
  }

  prepareImportResults(data) {
    return data.orphanExemptionDrugImports;
  }

  getImport(importId) {
    return this.orphanExemptionDrugImportsService.get(importId);
  }

  updateImport(importId, name) {
    return this.orphanExemptionDrugImportsService.update(importId, name);
  }

  cancelImport(importId) {
    return this.orphanExemptionDrugImportsService.cancel(importId);
  }
}
